import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Home } from "./components/Home";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Team } from "./components/Team";
import { Donate } from "./components/donate";
import JsonData from "./data/data.json";
import AboutPage from "./pages/AboutPage";
import NewsPage from "./pages/news";
import NewsfeedPage from "./pages/newsfeed";
import PaymentAccounts from "./pages/PaymentAccounts";
import ContactPage from "./pages/contact";
import DonorsPage from "./pages/donors";
import GalleryPage from "./pages/gallery";
import DonationHistoryPage from "./pages/donationHistory";
import NovicesPage from "./pages/novices";
import NoviceDetailsPage from "./pages/noviceDetails";
import VideosPage from "./pages/videos";
import FAQPage from "./pages/faq";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import { Footer } from "./components/footer";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const HOME_PAGE_TITLE = "သာသနာ့ပျိုးဥယျာဉ်ကျောင်းတိုက်";
const TITLE_MAP = {
  "/": HOME_PAGE_TITLE,
  "/about": "သာ/ပျိုးအကြောင်း",
  "/news": "သတင်းများ",
  "/newsfeed": "Newsfeed",
  "/videos": "ရုပ်သံဖိုင်များ",
  "/accounts": "သာသနာ့အလှူ",
  "/contact": "ဆက်သွယ်ရန်",
  "/donors": "အလှူရှင်များ",
  "/gallery": "Gallery",
  "/donation-history": "အလှူမှတ်တမ်း",
  "/novices": "သာမဏေများ",
  "/faq": "အမေးအဖြေများ",
};

const capitalize = (value) => value.charAt(0).toUpperCase() + value.slice(1);

const TitleUpdater = () => {
  const location = useLocation();

  useEffect(() => {
    let nextTitle = TITLE_MAP[location.pathname];
    if (!nextTitle) {
      if (location.pathname.startsWith("/novices/")) {
        nextTitle = "Novice Details";
      } else if (location.pathname === "*") {
        nextTitle = HOME_PAGE_TITLE;
      } else {
        const segments = location.pathname
          .split("/")
          .filter(Boolean)
          .map(capitalize);
        nextTitle = segments.length
          ? `${segments.join(" - ")} | Sasan Nursery`
          : HOME_PAGE_TITLE;
      }
    }

    document.title = nextTitle;
  }, [location]);

  return null;
};

const HomePage = ({ landingPageData }) => (
  <div>
    <Home data={landingPageData.Header} />
    <Features data={landingPageData.Features} />
    <About
      aboutData={landingPageData.About}
      aimData={landingPageData.Aim}
    />
    <Team data={landingPageData.Team} />
    <Donate />
    <Footer />
  </div>
);

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage landingPageData={landingPageData} />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/newsfeed" element={<NewsfeedPage />} />
        <Route path="/videos" element={<VideosPage />} />
        <Route path="/accounts" element={<PaymentAccounts />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/donors" element={<DonorsPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/donation-history" element={<DonationHistoryPage />} />
        <Route path="/novices" element={<NovicesPage />} />
        <Route path="/novices/:id" element={<NoviceDetailsPage />} />
        <Route path="*" element={<HomePage landingPageData={landingPageData} />} />
      </Routes>
      <TitleUpdater />
    </BrowserRouter>
  );
};

export default App;
